<template>
    <div class="camp">
        <h1>STEM 夏令营</h1>
        
        <!-- <div class="section" v-for="(content, index) in sections" :key="index" style="white-space: break-spaces;">
            <h2>{{ content.title }}</h2>
            <p v-if="content.body" style="text-align: justify;">&emsp;&emsp;{{ content.body }}</p>
        </div> -->
        
        <!-- Optional: Include images or illustrations related to the laboratory -->
        
        <div class="section" v-if="hasImages">
            <h2>近期项目</h2>
            <div class="flex-container">
                <div class="flex-item" v-for="(image, index) in images" :key="index">
                    <img v-loading="{ minHeight: '30px', minWidth: '30px', size: '25px' }" :src="require('../assets/images/Camp/' + image.src)" :alt="image.alt">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        sections: [
            {
                title: '',
                body: '',
            }
        ],
        //Images array can be added here if available
        images: [
            { src: "0.png", alt: '2025 NUS 高中生短期学习项目介绍 1' },
            { src: "1.png", alt: '2025 NUS 高中生短期学习项目介绍 2' },
            { src: "2.png", alt: '2025 NUS 高中生短期学习项目介绍 3' },
        ],
        hasImages: true, // Set to true if images array is defined
        };
    },
};
</script>

<style scoped>
/* Add basic styling for readability */
.camp {
    padding: 6vw;
    font-family: 'FangYuan';
    color: #513890;
    font-size: 1rem;
    font-weight: normal;
    letter-spacing: 0.16em;
    line-height: 2em;
}

body {
    line-height: 1.6;
    margin: 0;
    padding: 0;
}

h1 {
    text-align: center;
    margin-top: 3rem;
}

.section {
    margin-bottom: 2rem;
}

h2 {
    margin-top: 2rem;
}

ul {
    display: flex;
    list-style-type: disc;
    margin-left: 1.5rem;
    margin-bottom: 1rem;
}

ul li{
    display: inline;
    flex: 1;
    text-align: left;
}

p {
    margin-bottom: 1rem;
}

.highlight {
    font-weight: bold;
}

.flex-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 1rem;
}

.flex-item {
    /* flex-basis: calc(50% - 1rem); */
    margin-bottom: 1rem;
}

img {
    max-width: 100%;
    height: auto;
}

@media screen and (max-width: 768px) {
    .flex-item {
        flex-basis: 100%;
    }
}
</style>